export default __webpack_public_path__ + "static/media/41-min.b40ae1e0.jpg";